import { beerEmoji, puppyEmoji } from "./constants";
import { Button } from "./button";

export const Question = ({ question, handleAnswer }: { question: 'beer' | 'puppy', handleAnswer: (question: 'beer' | 'puppy', answer: 'yes' | 'no') => void }) => {
  const questionText = question === 'beer' 
  ? `Would you have 2 beers ${beerEmoji} with this person?`
  : `Would you allow this person to look after your puppy ${puppyEmoji} over a weekend?`;

  return (
    <div className="step-container">
      <div className="content-card">
        <h2>Think of a person.</h2>
        <p className="question-text">{questionText}</p>
        <div className="answer-buttons">
          <Button className="answer-button yes" onClick={() => handleAnswer(question, 'yes')} label="Yes" />
          <Button className="answer-button no" onClick={() => handleAnswer(question, 'no')} label="No" />
        </div>
      </div>
    </div>
  );
}
